export default {
    "name": "HomeTransferOrders",
    "kind": "HoudiniQuery",
    "hash": "bc3ab5b6ed9c92abe47efdf2b3005f4a55c2583d6cd5c9a48a5c939f2d339e03",

    "raw": `query HomeTransferOrders($filter: TransferOrderFilter) {
  transferOrders(filter: $filter) {
    items {
      id
      date
      destinationComment
      destinationStore {
        code
        name
        id
      }
      doneReceiving
      ordered
      sourceComment
      sourceStore {
        code
        name
        id
      }
      timeEntered
      user {
        name
        id
      }
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "transferOrders": {
                "type": "TransferOrderList",
                "keyRaw": "transferOrders(filter: $filter)",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "TransferOrder",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "date": {
                                        "type": "Date",
                                        "keyRaw": "date",
                                        "visible": true
                                    },

                                    "destinationComment": {
                                        "type": "String",
                                        "keyRaw": "destinationComment",
                                        "visible": true
                                    },

                                    "destinationStore": {
                                        "type": "Store",
                                        "keyRaw": "destinationStore",

                                        "selection": {
                                            "fields": {
                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "doneReceiving": {
                                        "type": "Boolean",
                                        "keyRaw": "doneReceiving",
                                        "visible": true
                                    },

                                    "ordered": {
                                        "type": "Boolean",
                                        "keyRaw": "ordered",
                                        "visible": true
                                    },

                                    "sourceComment": {
                                        "type": "String",
                                        "keyRaw": "sourceComment",
                                        "visible": true
                                    },

                                    "sourceStore": {
                                        "type": "Store",
                                        "keyRaw": "sourceStore",

                                        "selection": {
                                            "fields": {
                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "timeEntered": {
                                        "type": "DateTime",
                                        "keyRaw": "timeEntered",
                                        "visible": true
                                    },

                                    "user": {
                                        "type": "UserAccount",
                                        "keyRaw": "user",

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "TransferOrderFilter"
        },

        "types": {
            "UserAccountFilter": {
                "authorizedStores": "UInt",
                "id": "UInt",
                "isSalesPerson": "Boolean",
                "name": "String",
                "status": "UserAccountStatusEnum"
            },

            "DateFilter": {
                "eq": "Date",
                "gt": "Date",
                "gte": "Date",
                "lt": "Date",
                "lte": "Date",
                "ne": "Date"
            },

            "StoreFilter": {
                "id": "UInt",
                "name": "String"
            },

            "TransferOrderFilter": {
                "createdByUser": "UserAccountFilter",
                "date": "DateFilter",
                "doneReceiving": "Boolean",
                "ownerStore": "StoreFilter",
                "void": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=5f3988cc08f96867cb4b1176b8a59523fd996a6aebb080f7227a0eda1e78b01c";